import cx from 'classnames';
import * as React from 'react';

import styles from './Loader.module.scss';

export const Loader = () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.heroImage} />
            <main className={styles.drawer}>
                <div className={cx(styles.loadingBase, styles.title)} />
                <div className={cx(styles.loadingBase, styles.text)} />
                <div className={cx(styles.loadingBase, styles.text)} />
                <div className={cx(styles.loadingBase, styles.text)} />
                <div className={cx(styles.loadingBase, styles.text)} />
            </main>
        </div>
    );
};
